import { render, staticRenderFns } from "./CabinGroup.vue?vue&type=template&id=c0e41efa&scoped=true&"
import script from "./CabinGroup.vue?vue&type=script&lang=js&"
export * from "./CabinGroup.vue?vue&type=script&lang=js&"
import style0 from "./CabinGroup.vue?vue&type=style&index=0&id=c0e41efa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e41efa",
  null
  
)

export default component.exports